/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentDetailTranscriptionQueryResponse, WebAppGetFragmentDetailTranscriptionPathParams, WebAppGetFragmentDetailTranscription404 } from "../models/WebAppGetFragmentDetailTranscription";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { webAppGetFragmentDetailTranscription } from "../axios/webAppGetFragmentDetailTranscription";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const webAppGetFragmentDetailTranscriptionSuspenseQueryKey = (id: WebAppGetFragmentDetailTranscriptionPathParams["id"]) => ["api-v2", { url: '/web-app/v1/fragments/:id/transcription', params: {id:id} }] as const

export type WebAppGetFragmentDetailTranscriptionSuspenseQueryKey = ReturnType<typeof webAppGetFragmentDetailTranscriptionSuspenseQueryKey>

export function webAppGetFragmentDetailTranscriptionSuspenseQueryOptions(id: WebAppGetFragmentDetailTranscriptionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetFragmentDetailTranscriptionSuspenseQueryKey(id)
        return queryOptions<WebAppGetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailTranscription404>, WebAppGetFragmentDetailTranscriptionQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetFragmentDetailTranscription(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get fragment transcription
 * {@link /web-app/v1/fragments/:id/transcription}
 */
export function useWebAppGetFragmentDetailTranscriptionSuspense<TData = WebAppGetFragmentDetailTranscriptionQueryResponse, TQueryKey extends QueryKey = WebAppGetFragmentDetailTranscriptionSuspenseQueryKey>(id: WebAppGetFragmentDetailTranscriptionPathParams["id"], options: 
{
  query?: Partial<UseSuspenseQueryOptions<WebAppGetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailTranscription404>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetFragmentDetailTranscriptionSuspenseQueryKey(id)
         

         const query = useSuspenseQuery({
          ...webAppGetFragmentDetailTranscriptionSuspenseQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<WebAppGetFragmentDetailTranscription404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}